import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { IPreliminaryInvoicePayer } from '../interface/invoice';
import { useAnalytics } from './useAnalytics';
import { AnalyticsFeatureOperation } from '../interface/analytics';
import { IActionDto } from '../interface/common';
const skipPreliminaryInvoiceReview = async ({
  id,
  version,
}: IActionDto): Promise<IPreliminaryInvoicePayer> => {
  return post(
    API_URLS_ENTITY.PRELIMINARY_INVOICES + `/${id}/skip`,
    { version },
    {
      skipGlobalErrorHandler: true,
    },
  );
};

export const useSkipPreliminaryInvoiceReview = (): UseMutationResult<
  IPreliminaryInvoicePayer,
  AxiosError<{ message?: string; type?: string }>,
  IActionDto
> => {
  const { setIsLoading } = useLoading();
  const { trackBusinessEvent } = useAnalytics();

  return useMutation({
    mutationFn: skipPreliminaryInvoiceReview,
    onMutate: () => {
      trackBusinessEvent(AnalyticsFeatureOperation.PRELIMINARY_INVOICE_REVIEW_SKIPPED);
      setIsLoading(true);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
